import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { IdentityProvidersTableProps } from 'pages/Settings/IdentityProvidersPage/IdentityProviders';
import { excludeNullAndUndefined } from 'utils/array';
import { updateIdentityProvider } from 'utils/identity_providers';

const errorMessage = 'Unable to save Username Identifier.';

const maxIdentityProviderNameLength = 100;

export function IdentityProviderUsernameCell({
    rowData,
    onChange,
}: IdentityProvidersTableProps) {
    const onSave = async (newValue: string | undefined) => {
        if (!newValue) {
            return errorMessage;
        }
        try {
            await updateIdentityProvider(rowData, {
                UsernameIdentifiers: newValue.split(','),
            });
            onChange();
        } catch {
            return errorMessage;
        }
        return undefined;
    };
    return (
        <TextInlineEditor
            onConfirm={onSave}
            value={rowData.UsernameIdentifiers.join(',')}
            validate={(value: string | undefined) => {
                if (!value) {
                    return 'Username Identifier is required';
                }
                const errorMessages = excludeNullAndUndefined(
                    value.split(',').map((username) => {
                        if (username.length > maxIdentityProviderNameLength) {
                            return 'Username Identifier is too long';
                        }
                        return undefined;
                    }),
                );
                if (errorMessages.length > 0) {
                    return errorMessages[0];
                }
                return undefined;
            }}
        />
    );
}
